import React from 'react';
import '../../styles/components/landing/DownloadSection.css';

const AppleLogo = (props) => (
  <svg viewBox="0 0 384 512" width="28" height="28" aria-hidden="true" {...props}>
    <path
      fill="currentColor"
      d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
    />
  </svg>
);

const GooglePlayLogo = (props) => (
  <svg viewBox="0 0 512 512" width="26" height="26" aria-hidden="true" {...props}>
    <path fill="#00C3FF" d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1z" />
    <path fill="#1A73E8" d="M47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0z" />
    <path fill="#FBBC04" d="M472.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8z" />
    <path fill="#EA4335" d="M104.6 499l280.8-161.2-60.1-60.1L104.6 499z" />
  </svg>
);

const DEFAULT_NOTICE = (
  <>
    Estamos finalizando a submissão às lojas.{' '}
    <a href="mailto:suporte@lifyup.com.br?subject=Notificar%20lan%C3%A7amento">
      Receba aviso por e-mail no lançamento
    </a>
    .
  </>
);

const handleUnavailable = (e, store) => {
  e.preventDefault();
  alert(
    `O app ainda não foi publicado na ${store}. Estamos finalizando o processo de submissão.\n\n` +
    `Envie um e-mail para suporte@lifyup.com.br com o assunto "Notificar lançamento" e te avisaremos assim que estiver disponível.`,
  );
};

const DownloadSection = ({
  eyebrow = 'Disponível em breve',
  title = 'Baixe o LifeUp no seu celular',
  description = 'Toda a experiência LifeUp acontece dentro do app — programas, comunidade, IA Companion e protocolo de emergência. Comece gratuitamente e desbloqueie o Premium quando quiser.',
  notice = DEFAULT_NOTICE,
  appleHref = '#',
  googleHref = '#',
  onAppleClick,
  onGoogleClick,
}) => (
  <section className="ls-download" id="download" aria-labelledby="ls-download-title">
    <div className="container">
      <div className="ls-download__inner">
        <div className="ls-download__copy">
          <span className="ls-download__eyebrow">{eyebrow}</span>
          <h2 id="ls-download-title">{title}</h2>
          <p>{description}</p>
          {notice && <p className="ls-download__notice">{notice}</p>}
        </div>

        <div className="ls-download__stores" role="group" aria-label="Lojas de aplicativos">
          <a
            href={appleHref}
            className="ls-store-btn ls-store-btn--apple"
            onClick={onAppleClick || ((e) => handleUnavailable(e, 'App Store'))}
            aria-label="Baixar na App Store (em breve)"
          >
            <AppleLogo className="ls-store-btn__logo" />
            <span className="ls-store-btn__text">
              <small>Em breve na</small>
              <strong>App&nbsp;Store</strong>
            </span>
          </a>
          <a
            href={googleHref}
            className="ls-store-btn ls-store-btn--google"
            onClick={onGoogleClick || ((e) => handleUnavailable(e, 'Google Play'))}
            aria-label="Baixar no Google Play (em breve)"
          >
            <GooglePlayLogo className="ls-store-btn__logo" />
            <span className="ls-store-btn__text">
              <small>Disponível em breve no</small>
              <strong>Google&nbsp;Play</strong>
            </span>
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default DownloadSection;
